export const buildRatingScaleMaps = (assessment) => {
  const ratingScaleMaps = [];
  assessment.assignment_rubric.rating_scales.forEach((scale) => {
    const ratingScaleMap = {
      outcome_id: scale.criteria_id,
      rating_scale_id: scale.ddl_id,
    };
    ratingScaleMaps.push(ratingScaleMap);
  });
  return ratingScaleMaps;
};
